:host {
  --aha-tree--gap: calc(var(--spacer-1) / 2);
}
#content {
  display: flex;
  flex-direction: column;
  gap: var(--aha-tree--gap);
  width: 100%;
  max-width: 100%;
  min-height: var(--spacer-6);
  position: relative;
}

/* If the host has the `lines` option set, then make the child `aha-tree-item` elements have a special background. */
:host([lines]) ::slotted(*) {
  --aha-tree-item--background: var(--aha-tree-item--line-background);
}

/* Style the spinning icon. When the spinner is present, slotted aha-tree-items should be 0.3 opaque. */
#spinner {
  position: absolute;
  width: 100%;
  height: 100%;
  max-height: var(--spacer-6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
slot {
  visibility: hidden;
}
#spinner[aria-hidden='true'] {
  display: none;
}
#spinner[aria-hidden='true'] + slot {
  visibility: visible;
}
